module.exports = __webpack_public_path__ + "img/download-file.233b0ae0.svg";